
(function () {
  var track = document.querySelector('[data-jn-fy]');
  if (!track) return;

  var colType = track.dataset.colType || '';

  // ---- helpers ----
  function withWidth(url, w) {
    if (!url) return url;
    try {
      var u = new URL(String(url).replace(/^\/\//, 'https://'), location.origin);
      u.searchParams.set('width', String(w));
      return u.toString();
    } catch(e) {
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }
  }

  function getCookie(n) {
    var c = document.cookie.split(';').map(function(s){return s.trim();}).find(function(s){return s.startsWith(n+'=');});
    return c ? decodeURIComponent(c.slice(n.length + 1)) : null;
  }

  function isBraType(t) { return /bra|bralette|bustier|corset|camisole|chemise|slip/.test((t||'').toLowerCase()); }
  function isPantyType(t) { return /thong|brief|bikini|high.?waist|hipster|boyshort|hosiery|shorties|underwear|knicker/.test((t||'').toLowerCase()); }

  function fetchJSON(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; });
  }

  // ---- size matching (mirrors shopping-help.liquid matchSize logic) ----
  function normCup(c) {
    var m = { E: 'DD', F: 'DDD' };
    var u = (c || '').toUpperCase();
    return m[u] || u;
  }
  function cupAliases(c) {
    var u = normCup(c);
    var alt = { DD: 'E', DDD: 'F' };
    return alt[u] ? [u, alt[u]] : [u];
  }
  function matchesSize(variants, band, cup) {
    var band_s = String(band);
    var aliases = cupAliases(cup);
    var targets = aliases.map(function(c) { return (band_s + c).toUpperCase(); });
    if (!variants || !variants.length) return true;
    // 1. Band+cup metafields (unwrap arrays — Shopify can return them as arrays)
    if (variants.some(function(v) {
      if (!v.available) return false;
      var bs = Array.isArray(v.band_size) ? v.band_size[0] : v.band_size;
      var cs = Array.isArray(v.cup_size)  ? v.cup_size[0]  : v.cup_size;
      if (!bs || !cs) return false;
      return String(bs) === band_s && aliases.indexOf(normCup(String(cs).toUpperCase())) > -1;
    })) return true;
    // 2. Size option (e.g. "34DD") — covers bra-sized variants without metafields
    if (variants.some(function(v) {
      if (!v.available) return false;
      return targets.indexOf((v.size || '').toUpperCase().trim()) > -1;
    })) return true;
    // 3. Fits metafield — covers letter-sized products (e.g. "S fits 32A-34B")
    if (variants.some(function(v) {
      if (!v.available || !v.fits) return false;
      return v.fits.split(',').some(function(s) { return targets.indexOf(s.trim().toUpperCase()) > -1; });
    })) return true;
    // 4. No size data at all — can't filter, include product
    var hasSizeData = variants.some(function(v) {
      var bs = Array.isArray(v.band_size) ? v.band_size[0] : v.band_size;
      return bs || v.fits;
    });
    return !hasSizeData;
  }

  // ---- size-matched best sellers ----
  function fetchSizeMatched(braSize) {
    if (!braSize || !braSize.band || !braSize.cup) return Promise.resolve([]);
    var band = braSize.band;
    var cup  = braSize.cup;
    return fetchJSON('/collections/bras?view=fit-quiz&sort_by=best-selling').then(function(data) {
      if (!data) return [];
      var results = [];
      var products = data.products || [];
      for (var i = 0; i < products.length && results.length < 4; i++) {
        var p = products[i];
        if (!p.available) continue;
        if (matchesSize(p.variants, band, cup)) results.push(p);
      }
      return results;
    });
  }

  function matchesPantySize(variants, pantySize) {
    if (!variants || !variants.length) return true;
    var sz = (pantySize || '').toUpperCase().trim();
    var hasSizeData = false;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var vSz = (v.size || '').toUpperCase().trim();
      if (!vSz) continue;
      hasSizeData = true;
      if (!v.available) continue;
      if (vSz === sz) return true;
      // slash-combined sizes like "S/M"
      if (vSz.split('/').map(function(s){return s.trim();}).indexOf(sz) > -1) return true;
    }
    return !hasSizeData;
  }

  function fetchPantySizeMatched(pantySize) {
    if (!pantySize) return Promise.resolve([]);
    return fetchJSON('/collections/womens-panties?view=fit-quiz&sort_by=best-selling').then(function(data) {
      if (!data) return [];
      var results = [];
      var products = data.products || [];
      for (var i = 0; i < products.length && results.length < 3; i++) {
        var p = products[i];
        if (!p.available) continue;
        if (matchesPantySize(p.variants, pantySize)) results.push(p);
      }
      return results;
    });
  }

  // ---- main ----
  function init() {
    var families = [];
    try { families = JSON.parse(localStorage.getItem('jn_viewed_families') || '[]'); } catch(e) {}

    var braSize = null;
    try { braSize = JSON.parse(getCookie('jfq_bra_sz') || 'null'); } catch(e) {}
    if (braSize && (!braSize.band || !braSize.cup)) braSize = null;

    var pantySize = null;
    try {
      var dressCookie = JSON.parse(getCookie('jfq_dress_sz') || localStorage.getItem('jfq_dress_sz') || 'null');
      if (dressCookie && dressCookie.pantySize) pantySize = dressCookie.pantySize;
    } catch(e) {}

    // Parallel: fetch cart + size-matched products
    Promise.all([
      fetchJSON('/cart.js'),
      fetchSizeMatched(braSize),
      fetchPantySizeMatched(pantySize)
    ]).then(function(results) {
      var cart = results[0];
      var sizeMatched  = results[1] || [];
      var pantyMatched = results[2] || [];

      var picks = [];
      var seen = {};

      // 1. Recently Viewed — fetch top 2 viewed product handles
      var rvHandles = families.slice(0, 6).map(function(f){ return f.productHandle; }).filter(Boolean);
      var rvFetches = rvHandles.map(function(h){ return fetchJSON('/products/' + h + '.js'); });

      Promise.all(rvFetches).then(function(rvProducts) {
        rvProducts.forEach(function(p) {
          if (!p || seen[p.handle] || picks.filter(function(x){return x.badge === 'Viewed';}).length >= 6) return;
          seen[p.handle] = true;
          var img = (typeof p.featured_image === 'string' ? p.featured_image : null)
                 || (Array.isArray(p.images) && p.images[0] ? String(p.images[0]) : null);
          picks.push({ url: '/products/' + p.handle, image: img, title: p.title, badge: 'Viewed' });
        });

        // 2. Complete the Look — up to 4 picks from the most recent cart item, then up to 2 from the next oldest.
        // Uses product_type from cart.js so direction is always correct even if the item was never browsed.
        if (cart && cart.items && cart.items.length && families.length) {
          var ctlSlots = [{ item: cart.items[cart.items.length - 1], max: 4 }];
          if (cart.items.length >= 2) ctlSlots.push({ item: cart.items[cart.items.length - 2], max: 2 });

          for (var ci = 0; ci < ctlSlots.length; ci++) {
            var ctlCartItem = ctlSlots[ci].item;
            var ctlMax      = ctlSlots[ci].max;
            var cartIsBra   = isBraType(ctlCartItem.product_type);
            var cartIsPanty = isPantyType(ctlCartItem.product_type);
            if (!cartIsBra && !cartIsPanty) continue;

            var ctlHandle  = ctlCartItem.handle;
            var cartFamily = families.find ? families.find(function(f) { return f.productHandle === ctlHandle; }) : null;
            // Pass 1 (newest item): fall through to all viewed families if exact family not found.
            // Pass 2+ (older items): only use the exact family — prevents showing wrong colorways from unrelated families.
            var familyQueue = cartFamily
              ? [cartFamily].concat(ci === 0 ? families.filter(function(f) { return f !== cartFamily; }) : [])
              : (ci === 0 ? families.slice() : []);

            var ctlCount = 0;
            for (var fi = 0; fi < familyQueue.length && ctlCount < ctlMax; fi++) {
              var famProds = familyQueue[fi].products || [];
              for (var pi = 0; pi < famProds.length && ctlCount < ctlMax; pi++) {
                var cp = famProds[pi];
                if (!cp.handle || seen[cp.handle]) continue;
                var isTarget = (cartIsBra && isPantyType(cp.type || cp.title)) ||
                               (cartIsPanty && isBraType(cp.type || cp.title));
                if (!isTarget) continue;
                seen[cp.handle] = true;
                picks.push({ url: cp.url || ('/products/' + cp.handle), image: cp.image || null, title: cp.title, badge: 'Complete the Look' });
                ctlCount++;
              }
            }
          }
        }

        // 3. Best sellers in your size — bras (cap at 3 when panties also available)
        var braLimit = pantyMatched.length > 0 ? 3 : 4;
        var ysCount = 0;
        sizeMatched.forEach(function(p) {
          if (ysCount >= braLimit) return;
          var handle = p.handle;
          if (!handle || seen[handle]) return;
          seen[handle] = true;
          picks.push({ url: p.url || ('/products/' + handle), image: p.image || null, title: p.name || p.title, badge: 'Your Size' });
          ysCount++;
        });

        // 4. Best sellers in your panty size — mixed into same group
        var ypCount = 0;
        pantyMatched.forEach(function(p) {
          if (ypCount >= 2) return;
          var handle = p.handle;
          if (!handle || seen[handle]) return;
          seen[handle] = true;
          picks.push({ url: p.url || ('/products/' + handle), image: p.image || null, title: p.name || p.title, badge: 'Your Size' });
          ypCount++;
        });

        render(picks);
      });
    });
  }

  function esc(s) { return String(s || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

  var SECTION_LABELS = {
    'Viewed':              'Recently Viewed',
    'Complete the Look':   'Complete the Look',
    'Your Size':           'Popular in Your Size'
  };

  function render(picks) {
    var details = track.closest ? track.closest('.jn-fy') : null;
    if (!picks.length) {
      if (details) details.hidden = true;
      return;
    }

    // Group picks by badge, preserving order
    var groups = [];
    picks.forEach(function(p) {
      if (!groups.length || groups[groups.length - 1].badge !== p.badge) {
        groups.push({ badge: p.badge, items: [] });
      }
      groups[groups.length - 1].items.push(p);
    });

    var html = '';
    groups.forEach(function(group) {
      var label = SECTION_LABELS[group.badge] || group.badge;
      html += '<div class="jn-fy__group"><p class="jn-fy__group-label">' + esc(label) + '</p><div class="jn-fy__group-cards">';
      group.items.forEach(function(p) {
        var imgTag = p.image
          ? '<img src="' + esc(withWidth(p.image, 240)) + '" alt="' + esc(p.title) + '" loading="lazy">'
          : '';
        html += '<a href="' + esc(p.url) + '" class="jn-fy__card">' +
                  '<div class="jn-fy__img-wrap">' + imgTag + '</div>' +
                  '<p class="jn-fy__name">' + esc(p.title) + '</p>' +
                '</a>';
      });
      html += '</div></div>';
    });

    track.innerHTML = html;
  }

  // Skeleton placeholder shown while async fetches run
  function renderSkeleton() {
    var html = '';
    for (var i = 0; i < 3; i++) {
      html += '<div class="jn-fy__group jn-fy__skel-group"><div class="jn-fy__skel-label"></div><div class="jn-fy__group-cards">';
      for (var j = 0; j < 3; j++) {
        html += '<div class="jn-fy__card"><div class="jn-fy__img-wrap jn-fy__skel-card"></div><div class="jn-fy__skel-name"></div></div>';
      }
      html += '</div></div>';
    }
    track.innerHTML = html;
  }

  // Collapse preference with 1-hour TTL
  var PREF_KEY = 'jn_fy_open';
  var PREF_TTL = 60 * 60 * 1000;
  function readOpenPref() {
    try {
      var d = JSON.parse(localStorage.getItem(PREF_KEY) || 'null');
      if (!d || Date.now() > d.expires) { localStorage.removeItem(PREF_KEY); return null; }
      return d.open;
    } catch(e) { return null; }
  }
  function writeOpenPref(open) {
    try { localStorage.setItem(PREF_KEY, JSON.stringify({ open: open, expires: Date.now() + PREF_TTL })); } catch(e) {}
  }

  var details = track.closest ? track.closest('.jn-fy') : null;
  if (details) {
    var pref = readOpenPref();
    if (pref === false) details.removeAttribute('open');
    details.addEventListener('toggle', function() { writeOpenPref(details.open); });
  }

  // Only show the skeleton if we have a reasonable expectation of content.
  // Recently Viewed and Your Size are knowable synchronously; the cart requires a fetch so it's the wildcard.
  var hasViewed = false;
  try { hasViewed = JSON.parse(localStorage.getItem('jn_viewed_families') || '[]').length > 0; } catch(e) {}
  var hasBraSize   = !!getCookie('jfq_bra_sz');
  var hasPantySize = !!getCookie('jfq_dress_sz');
  if (hasViewed || hasBraSize || hasPantySize) renderSkeleton();
  init();
})();

// ---------- Popular in Your Size strip ----------
(function () {
  var container = document.querySelector('[id^="jn-pys-"]');
  if (!container) return;

  var sectionId = container.dataset.section;
  var minProducts = parseInt(container.dataset.min || '4', 10);
  var dataEl = document.getElementById('jn-pys-data-' + sectionId);
  var data = {};
  if (dataEl) {
    try { data = JSON.parse(dataEl.textContent || '{}'); } catch (e) { data = {}; }
  }

  function getCookie(n) {
    var c = document.cookie.split(';').map(function (s) { return s.trim(); }).find(function (s) { return s.startsWith(n + '='); });
    return c ? decodeURIComponent(c.slice(n.length + 1)) : null;
  }

  function esc(s) { return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  function withWidth(url, w) {
    if (!url) return url;
    try { var u = new URL(String(url).replace(/^\/\//, 'https://'), location.origin); u.searchParams.set('width', String(w)); return u.toString(); }
    catch (e) { return url; }
  }

  function formatPrice(cents) {
    if (!cents) return '';
    var d = cents / 100;
    return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2));
  }

  function findMatch(data, min) {
    // 1. Bra size: jfq_bra_sz cookie → {band, cup} → key "34D"
    try {
      var bra = JSON.parse(getCookie('jfq_bra_sz') || 'null');
      if (bra && bra.band && bra.cup) {
        var key = String(bra.band) + bra.cup.toUpperCase();
        if (data[key] && data[key].length >= min) return { key: key, label: key };
      }
    } catch (e) {}

    // 2. Dress/panty size: jfq_dress_sz cookie → {dressSize (number), pantySize (letter)}
    //    Worker keys are numeric ranges like "4-6", "8-10" — find narrowest match
    try {
      var dress = JSON.parse(getCookie('jfq_dress_sz') || localStorage.getItem('jfq_dress_sz') || 'null');
      if (dress) {
        var dressNum = typeof dress.dressSize === 'number' ? dress.dressSize : null;
        var pantyLabel = dress.pantySize || '';
        // Fall back to panty letter size when dressSize is null
        if (dressNum === null && dress.pantySize) {
          var pantySizeMap = { XS: 1, S: 5, M: 9, L: 13, XL: 17, XXL: 20, XXXL: 22 };
          var mapped = pantySizeMap[String(dress.pantySize).toUpperCase()];
          if (mapped != null) dressNum = mapped;
        }
        var best = null;
        Object.keys(data).forEach(function (key) {
          if (!data[key] || data[key].length < min) return;
          var m = key.match(/^(\d+)-(\d+)$/);
          if (m && dressNum != null) {
            var lo = parseInt(m[1], 10), hi = parseInt(m[2], 10);
            if (dressNum >= lo && dressNum <= hi) {
              var span = hi - lo;
              if (!best || span < best.span) best = { key: key, span: span, label: pantyLabel || key };
            }
          }
        });
        if (best) return best;
      }
    } catch (e) {}

    return null;
  }

  var match = findMatch(data, minProducts);

  // Build the ordered list of candidate strips (best first):
  //   1. size-specific "Popular in Your Size" list (size cookie matched a key
  //      with enough handles)
  //   2. the collection's custom.popular list (bestsellers)
  // We try them in order and render the first that yields enough *available*
  // products, so the popular list also backfills when the size cookie is
  // present but its size list is too short or too sold-out to fill the strip.
  var candidates = [];
  if (match) candidates.push({ handles: data[match.key], title: 'Popular in Your Size', label: match.label });

  var popEl = document.getElementById('jn-pys-popular-' + sectionId);
  if (popEl) {
    var popList;
    try { popList = JSON.parse(popEl.textContent || '[]'); } catch (e) { popList = null; }
    if (popList && popList.length >= minProducts) {
      candidates.push({ handles: popList, title: 'Popular', label: '' });
    }
  }

  if (!candidates.length) return;

  var stripTitle = candidates[0].title;
  var stripLabel = candidates[0].label;

  function headerHtml() {
    return '<div class="jn-pys__header">' +
      '<span class="jn-pys__title">' + esc(stripTitle) + '</span>' +
      (stripLabel ? '<span class="jn-pys__subtitle">' + esc(stripLabel) + '</span>' : '') +
    '</div>';
  }

  // Move container into product grid as a full-width slot after row 3
  var productList = document.getElementById('product-list-' + sectionId);
  var slot = null;
  if (productList) {
    slot = document.createElement('div');
    slot.className = 'jn-pys-slot';
    var gridItems = Array.from(productList.children);
    var cols = 2;
    if (gridItems.length) {
      var firstTop = Math.round(gridItems[0].getBoundingClientRect().top);
      cols = 0;
      for (var gi = 0; gi < gridItems.length; gi++) {
        if (Math.round(gridItems[gi].getBoundingClientRect().top) === firstTop) cols++;
        else break;
      }
      if (!cols) cols = 2;
    }
    var afterIdx = Math.min(cols * 3, gridItems.length);
    slot.style.setProperty('--jn-pys-cols', String(cols));
    slot.appendChild(container);
    if (afterIdx < gridItems.length) {
      productList.insertBefore(slot, gridItems[afterIdx]);
    } else {
      productList.appendChild(slot);
    }
  }

  // Show skeleton immediately while fetches run
  var skelCards = '';
  for (var i = 0; i < minProducts; i++) {
    skelCards += '<div class="jn-pys__card">' +
      '<div class="jn-pys__skel-img"></div>' +
      '<div class="jn-pys__skel-line jn-pys__skel-line--short"></div>' +
      '<div class="jn-pys__skel-line jn-pys__skel-line--long"></div>' +
      '<div class="jn-pys__skel-line jn-pys__skel-line--price"></div>' +
    '</div>';
  }
  container.innerHTML = headerHtml() + '<div class="jn-pys__track">' + skelCards + '</div>';
  container.style.display = '';

  function fetchAvailable(handleList) {
    var handles = handleList.slice(0, minProducts + 4);
    return Promise.all(handles.map(function (h) {
      return fetch('/products/' + h + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      return products.filter(function (p) { return p && p.available; });
    });
  }

  function renderCards(valid) {
    var shown = valid.slice(0, minProducts);
    var cards = shown.map(function (p) {
      var img = p.featured_image || (p.images && p.images[0] ? String(p.images[0]) : null);
      return '<a href="/products/' + esc(p.handle) + '" class="jn-pys__card">' +
        '<div class="jn-pys__img-wrap">' +
          (img ? '<img src="' + esc(withWidth(img, 340)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
        '</div>' +
        (p.vendor ? '<p class="jn-pys__vendor">' + esc(p.vendor) + '</p>' : '') +
        '<p class="jn-pys__name">' + esc(p.title) + '</p>' +
        '<p class="jn-pys__price">' + esc(formatPrice(p.price_min)) + '</p>' +
      '</a>';
    }).join('');
    container.innerHTML = headerHtml() + '<div class="jn-pys__track">' + cards + '</div>';
  }

  // Try each candidate in order; render the first with enough available
  // products, otherwise fall through. Hide the strip if none qualify.
  (function tryCandidate(idx) {
    if (idx >= candidates.length) {
      container.style.display = 'none';
      if (slot) slot.style.display = 'none';
      return;
    }
    stripTitle = candidates[idx].title;
    stripLabel = candidates[idx].label;
    fetchAvailable(candidates[idx].handles).then(function (valid) {
      if (valid.length < minProducts) { tryCandidate(idx + 1); return; }
      renderCards(valid);
    });
  })(0);
})();
